import { defaultTransformer } from "../utils/utils"
import { apiClient } from "./apiClient"

export const schemaApi = {
    /**
     * Fetch Component Config Schema for a given UTG Version
     * @param {string} utgVersion - The UTG Version
     * @returns {Promise} - The Config Schema as a Promise
     */
    fetchComponentConfigSchema: async (config, utgVersion) => {
        const url = `${config.managementApiUrl}/componentconfigschemas?componenttype=1&componentversion=${utgVersion}`
        return await apiClient(
            url,
            null,
            { },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        //console.log("Fetched the following componet config schema result:")
                        //console.log(result)
                        return result.componentConfigSchema
                    }
                )
            }
        )
    },
    /**
     * Fetch Local Component Config Schema during development
     * @returns {Promise} - The Config Schema as a Promise
     */
    fetchComponentConfigSchemaLocal: async (utgVersion) => {
        const url = `/schemas/configs/${utgVersion}/config-schema.json`
        return await apiClient(
            url,
            null,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                }
            },
            defaultTransformer
        )
    },
    /**
     * Fetch Device Schemas
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The Installation as a Promise
     */
    fetchDeviceSchemas: async (config, accessToken) => {
        const url = `${config.managementApiUrl}/componentDevices?version=2`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.componentDevice
                    }
                )
            }
        )
    },
    /**
     * Fetch Local Device Schemas during development
     * @returns {Promise} - The Schemas as a Promise
     */
    fetchDeviceSchemasLocal: async () => {
        const url = `/jsonform/lib/componentdevices.json`
        return await apiClient(
            url,
            null,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                }
            },
            defaultTransformer
        )
    }
}